import { render } from "./SelectCheckbox.vue?vue&type=template&id=a1c6b5a8"
import script from "./SelectCheckbox.vue?vue&type=script&lang=js"
export * from "./SelectCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__